import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function () {
  const mm = gsap.matchMedia();
  const expertiseContainer = document.querySelectorAll('.expertise .img-container');

  gsap.registerPlugin(ScrollTrigger);

  mm.add({
    desktop: "(min-width: 1024px)",
    reduceMotion: "(prefers-reduced-motion: reduce)"
  }, (context) => {

    const { desktop, reduceMotion } = context.conditions;

    expertiseContainer.forEach(container => {
      const imgFront = container.querySelector('.img.front');
      const imgBack = container.querySelector('.img.back');
      const number = container.querySelector('.number');
      const circle = container.querySelector('.circle');

      if (desktop && !reduceMotion) {

        const start = "top-=300px center";
        const end = "center+=25% center";
        const duration1 = 0.2;
        const duration2 = 0.6;
        const easing1 = "power2.in";
        const easing2 = "power2.out";

        gsap.timeline({
          scrollTrigger: {
            trigger: container,
            start,
            end
          }
        })
        .to(imgFront, {
          xPercent: -100,
          duration: duration1,
          ease: easing1
        })
        .to(imgFront, {
          clipPath: 'inset(0% 0% 0% 0%)',
          duration: duration2,
          ease: easing2
        })
        .to(number, { opacity: 1 }, ">-0.5");

        gsap.timeline({
          scrollTrigger: {
            trigger: container,
            start,
            end
          }
        })
        .to(imgBack, {
          xPercent: -100,
          duration: duration1,
          ease: easing1
        })
        .to(imgBack, {
          clipPath: 'inset(0% 100% 0% 0%)',
          rotateY: 180,
          xPercent: -300,
          duration: duration2,
          ease: easing2
        })
        .to(circle, {
          opacity: 1,
          rotation: 365
        }, ">-0.5");

      } else if (desktop && reduceMotion) {

        gsap.set(imgFront, {
          xPercent: -100,
          clipPath: 'inset(0% 0% 0% 0%)'
        });

        gsap.set(number, { opacity: 1 });

        gsap.set(imgBack, {
          xPercent: -300,
          clipPath: 'inset(0% 100% 0% 0%)',
          rotateY: 180
        });

        gsap.set(circle, {
          opacity: 1,
          rotation: 365
        });
      }
    });
  });
}
